export const AREA_RISERVATA_PAGES: Record<string, any> = {
    "/tpdweb/area_riservata/preventivi/acquista/spedizione-polizza": {
        "id": "gxsywmg-yajwjmufaoqtanjbffezznmpzuou",
        "url": "/tpdweb/area_riservata/preventivi/acquista/spedizione-polizza",
        "title": "Spedizione polizza",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-10-29"
    },
    "/tpdweb/area_riservata/sinistri/tracking-sinistri/riepilogo-visita": {
        "id": "gxsywmg-uvhyolgjonhvhudborgdujjduggh",
        "url": "/tpdweb/area_riservata/sinistri/tracking-sinistri/riepilogo-visita",
        "title": "Riepilogo visita",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-02-12"
    },
    "/tpdweb/area_riservata/telepedaggio-acquisto": {
        "id": "gxsywmg-zxfeqhxbjllpbhtfwvfommkesxhu",
        "url": "/tpdweb/area_riservata/telepedaggio-acquisto",
        "title": "Telepedaggio Acquisto",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/telematica-immobili": {
        "id": "gxsywmg-exdjfodtdgmequhtuucrotltxfmh",
        "url": "/tpdweb/area_riservata/telematica-immobili",
        "title": "Unibox immobili",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-31"
    },
    "/tpdweb/area_riservata/polizze/polizza/sanicard": {
        "id": "gxsywmg-ucpshdsrgnzfynjaqddvawggjxne",
        "url": "/tpdweb/area_riservata/polizze/polizza/sanicard",
        "title": "Sanicard",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/sinistri/tracking-sinistri/negazione-sinistro": {
        "id": "gxsywmg-zradajyekgglshovmffttdrnbjhe",
        "url": "/tpdweb/area_riservata/sinistri/tracking-sinistri/negazione-sinistro",
        "title": "Negazione sinistro",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/sinistri/tracking-sinistri": {
        "id": "gxsywmg-xjtplpxhecybqunmnyuudddulxnu",
        "url": "/tpdweb/area_riservata/sinistri/tracking-sinistri",
        "title": "I tuoi sinistri",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/polizze/polizza-previdenza": {
        "id": "gxsywmg-bmdhwozibmzsxutfjavlckzwxeoe",
        "url": "/tpdweb/area_riservata/polizze/polizza-previdenza",
        "title": "Polizza Previdenza",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-07-23"
    },
    "/tpdweb/area_riservata/completamento-registrazione": {
        "id": "gxsywmg-bhxdjpdzzdqdfhswgfbwczjslnnh",
        "url": "/tpdweb/area_riservata/completamento-registrazione",
        "title": "Completamento Registrazione",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-31"
    },
    "/tpdweb/area_riservata/sinistri/scelta-targa": {
        "id": "gxsywmg-xjtplpxhecybqugckvggwlfznbme",
        "url": "/tpdweb/area_riservata/sinistri/scelta-targa",
        "title": "Scelta targa",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2018-03-09"
    },
    "/tpdweb/area_riservata/preventivi": {
        "id": "gxsywmg-zqpmglyhfgsgnenzxtwoywkfrapu",
        "url": "/tpdweb/area_riservata/preventivi",
        "title": "Preventivi",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-11-14"
    },
    "/tpdweb/area_riservata/preventivi/esito": {
        "id": "gxsywmg-ycqobgflprgyjhwbmztqczrqvjpe",
        "url": "/tpdweb/area_riservata/preventivi/esito",
        "title": "Esito acquisto",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-11-14"
    },
    "/tpdweb/area_riservata/dati-personali/privacy": {
        "id": "gxsywmg-pswbkzpehzkfdhrjahngwmdmadin",
        "url": "/tpdweb/area_riservata/dati-personali/privacy",
        "title": "Privacy",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/sinistri/riepilogo-denuncia": {
        "id": "gxsywmg-ydialszwztztluqderjgdgbfbciu",
        "url": "/tpdweb/area_riservata/sinistri/riepilogo-denuncia",
        "title": "Riepilogo denuncia",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2017-10-10"
    },
    "/tpdweb/area_riservata/sinistri": {
        "id": "gxsywmg-xjtplpxhecybquqngxdieuwkwcne",
        "url": "/tpdweb/area_riservata/sinistri",
        "title": "Sinistri",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-05-07"
    },
    "/tpdweb/area_riservata/polizze/polizza-collettiva": {
        "id": "gxsywmg-ppishxrhrqkdeetyugddfpjhhhwu",
        "url": "/tpdweb/area_riservata/polizze/polizza-collettiva",
        "title": "Polizza collettiva",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-07-23"
    },
    "/tpdweb/area_riservata/sinistri/altri-rami": {
        "id": "gxsywmg-bdudqjvayvzjendvbgktosruhawn",
        "url": "/tpdweb/area_riservata/sinistri/altri-rami",
        "title": "Altri sinistri",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-05-07"
    },
    "/tpdweb/area_riservata/polizze/storico-pagamenti": {
        "id": "gxsywmg-axabowcaqzsyxellzpmzdbwagwcu",
        "url": "/tpdweb/area_riservata/polizze/storico-pagamenti",
        "title": "Storico pagamenti",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-12-18"
    },
    "/tpdweb/area_riservata/home": {
        "id": "gxsywmg-zifskdkwzdedxulsfseggpolskrh",
        "url": "/tpdweb/area_riservata/home",
        "title": "Area Riservata - Home page",
        "description": "home",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/polizze/informativa-rinnovo-polizza": {
        "id": "gxsywmg-edtconxqvsoyrehdqdfqxqwqkqve",
        "url": "/tpdweb/area_riservata/polizze/informativa-rinnovo-polizza",
        "title": "Informazioni e Condizioni di Pagamento",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/home-superuser": {
        "id": "gxsywmg-bbspplfnbfzhxhnbgbsvmprxhcue",
        "url": "/tpdweb/area_riservata/home-superuser",
        "title": "Home Super User",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-31"
    },
    "/tpdweb/area_riservata/servizi-mobilita": {
        "id": "gxsywmg-eocxmhtaakppjenyeonsrzkwvtin",
        "url": "/tpdweb/area_riservata/servizi-mobilita",
        "title": "Servizi per la mobilità",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/servizi-mobilita/telepedaggio": {
        "id": "gxsywmg-eocxmhtaakppjehhdiundgldxwpe",
        "url": "/tpdweb/area_riservata/servizi-mobilita/telepedaggio",
        "title": "Telepedaggio",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/sinistri/denuncia-due-veicoli": {
        "id": "gxsywmg-xtgxtinvxhtpgenyukqqfzyzrkne",
        "url": "/tpdweb/area_riservata/sinistri/denuncia-due-veicoli",
        "title": "Denuncia due veicoli",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-06-23"
    },
    "/tpdweb/area_riservata/home/aggiornamento-profilo/pin": {
        "id": "gxsywmg-xrmnylgtoqtbgehssddduaqimvee",
        "url": "/tpdweb/area_riservata/home/aggiornamento-profilo/pin",
        "title": "Inserimento Pin",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-09-17"
    },
    "/tpdweb/area_riservata/polizze": {
        "id": "gxsywmg-zifskdkwzdedxusdmwjgvgvxtkxn",
        "url": "/tpdweb/area_riservata/polizze",
        "title": "Le tue polizze",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-12-18"
    },
    "/tpdweb/area_riservata/home/aggiornamento-profilo": {
        "id": "gxsywmg-xrmnylgtoqtbgelqafflhsoegbln",
        "url": "/tpdweb/area_riservata/home/aggiornamento-profilo",
        "title": "Aggiorna profilo",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-09-17"
    },
    "/tpdweb/area_riservata/polizze/esito-rinnovo-polizza": {
        "id": "gxsywmg-edtconxqvsoyrerljwgtcuwpgwfe",
        "url": "/tpdweb/area_riservata/polizze/esito-rinnovo-polizza",
        "title": "Esito",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/polizze/polizza": {
        "id": "gxsywmg-zifskdkwzdedxucukzterfuttodh",
        "url": "/tpdweb/area_riservata/polizze/polizza",
        "title": "Dettaglio polizza",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/polizze/polizza-rami-elementari": {
        "id": "gxsywmg-ihdznygblxhwrnoyyzmvlmcotltu",
        "url": "/tpdweb/area_riservata/polizze/polizza-rami-elementari",
        "title": "Polizza collettiva rami elementari",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-07-23"
    },
    "/tpdweb/area_riservata/sinistri/altri-rami/rami-elementari": {
        "id": "gxsywmg-bdudqjvayvzjengwawgigchjobvu",
        "url": "/tpdweb/area_riservata/sinistri/altri-rami/rami-elementari",
        "title": "Denuncia sinistri Rami elementari",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-05-07"
    },
    "/tpdweb/area_riservata/polizze/avanzamento-livello-servizi": {
        "id": "gxsywmg-yvgrgyowtnlemujvjlaauekbbmhn",
        "url": "/tpdweb/area_riservata/polizze/avanzamento-livello-servizi",
        "title": "Avanzamento livello servizi",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/dati-personali/gestione-utenze-aziendali": {
        "id": "gxsywmg-purgbcwvmizfdnrsjgmznoffnoke",
        "url": "/tpdweb/area_riservata/dati-personali/gestione-utenze-aziendali",
        "title": "Gestione Utenze Aziendali",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/sinistri/auto-e-moto": {
        "id": "gxsywmg-axabowcaqzsyxegtfchlgrvvpvxe",
        "url": "/tpdweb/area_riservata/sinistri/auto-e-moto",
        "title": "Denuncia sinistri Auto & Moto",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-05-07"
    },
    "/tpdweb/area_riservata/home/notifiche": {
        "id": "gxsywmg-vwinpmssojeljhtksheiuulmmocn",
        "url": "/tpdweb/area_riservata/home/notifiche",
        "title": "Notifiche",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/dati-personali": {
        "id": "gxsywmg-zifskdkwzdedxughhsxlrqgwtwcn",
        "url": "/tpdweb/area_riservata/dati-personali",
        "title": "Dati personali",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/preventivi/acquista": {
        "id": "gxsywmg-ycqobgflprgyjhjywxvekfpnajje",
        "url": "/tpdweb/area_riservata/preventivi/acquista",
        "title": "Acquista",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-10-29"
    },
    "/tpdweb/area_riservata/home/aggiornamento-profilo/esito": {
        "id": "gxsywmg-xrmnylgtoqtbgesgixfufrpkjdin",
        "url": "/tpdweb/area_riservata/home/aggiornamento-profilo/esito",
        "title": "Esito Aggiornamento Profilo",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-09-17"
    },
    "/tpdweb/area_riservata/richiesta-contatto": {
        "id": "gxsywmg-xtgxtinvxhtpgegrdqjqaxyvkodh",
        "url": "/tpdweb/area_riservata/richiesta-contatto",
        "title": "Richiesta Contatto",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "false",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2025-11-28"
    },
    "/tpdweb/area_riservata/sinistri/conferma-invio-denuncia": {
        "id": "gxsywmg-xuwnuwrarecgnunzxoqvdytyehdn",
        "url": "/tpdweb/area_riservata/sinistri/conferma-invio-denuncia",
        "title": "Conferma invio denuncia",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2017-10-12"
    },
    "/tpdweb/area_riservata/sinistri/denunce-inviate": {
        "id": "gxsywmg-xjtplpxhecybqunzbyfjhcollkhe",
        "url": "/tpdweb/area_riservata/sinistri/denunce-inviate",
        "title": "Denunce inviate",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2017-10-12"
    },
    "/tpdweb/area_riservata/sinistri/preapertura-sinistro": {
        "id": "gxsywmg-xjtplpxhecybquozflzursvhffpe",
        "url": "/tpdweb/area_riservata/sinistri/preapertura-sinistro",
        "title": "Preapertura sinistro",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2018-03-12"
    },
    "/tpdweb/area_riservata/preventivi/acquista/documenti": {
        "id": "gxsywmg-ycqobgflprgyjhtebxahsldmqgce",
        "url": "/tpdweb/area_riservata/preventivi/acquista/documenti",
        "title": "Documenti",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-10-29"
    },
    "/tpdweb/area_riservata/sinistri/tracking-sinistri/prenotazione-visita": {
        "id": "gxsywmg-uvhyolgjonhvhudiqqrggicubrde",
        "url": "/tpdweb/area_riservata/sinistri/tracking-sinistri/prenotazione-visita",
        "title": "Prenotazione visita",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2019-02-12"
    },
    "/tpdweb/area_riservata/esito-aggiunta-carta": {
        "id": "gxsywmg-ypqwczdqcsmgphtykcclbdsbojhe",
        "url": "/tpdweb/area_riservata/esito-aggiunta-carta",
        "title": "Esito Aggiunta Carta",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/polizze/pagamento-rinnovo-polizza": {
        "id": "gxsywmg-edtconxqvsoyrerqcjbcebjhmnah",
        "url": "/tpdweb/area_riservata/polizze/pagamento-rinnovo-polizza",
        "title": "Pagamento",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    },
    "/tpdweb/area_riservata/telematica-mobilita": {
        "id": "gxsywmg-exdjfodtdgmequjipmrbdasvhdmu",
        "url": "/tpdweb/area_riservata/telematica-mobilita",
        "title": "Unibox auto",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-31"
    },
    "/tpdweb/area_riservata/agenzia": {
        "id": "gxsywmg-yrkrlvhzhtebyuhlsghtbstwhlae",
        "url": "/tpdweb/area_riservata/agenzia",
        "title": "La tua agenzia",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-31"
    },
    "/tpdweb/area_riservata/sinistri/modifica-versione-controparte": {
        "id": "gxsywmg-zradajyekgglshlsppsfiusfemdh",
        "url": "/tpdweb/area_riservata/sinistri/modifica-versione-controparte",
        "title": "Modifica versione controparte",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/servizi-mobilita/telepedaggio/modifica-offerta": {
        "id": "gxsywmg-zrgxghqhcwdbdnlgpsxoptnynhru",
        "url": "/tpdweb/area_riservata/servizi-mobilita/telepedaggio/modifica-offerta",
        "title": "Modifica Offerta",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/servizi-mobilita/telepedaggio/apri-segnalazione": {
        "id": "gxsywmg-zrgxghqhcwdbdnhlcpbhzawcqwsh",
        "url": "/tpdweb/area_riservata/servizi-mobilita/telepedaggio/apri-segnalazione",
        "title": "Apri Segnlazione",
        "description": "",
        "layout": "layout-templates/1Column/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2023-10-30"
    },
    "/tpdweb/area_riservata/polizze/pagamento-insoluto": {
        "id": "gxsywmg-vovhxuongznjvuhjaasqsbwmmtie",
        "url": "/tpdweb/area_riservata/polizze/pagamento-insoluto",
        "title": "pagamento-insoluto",
        "description": "",
        "layout": "layout-templates/hp/",
        "isBusinessChild": "false",
        "newArchitecture": "true",
        "siteMapEnable": "true",
        "profile": "profiles/profile_unipolsai.json",
        "lastModified": "2024-05-07"
    }
};
